export const SET_CURRENT_URL = "SET_CURRENT_URL";
export const CLICKED_FOOTER_MERCHANT_FEATURES = "CLICKED_FOOTER_MERCHANT_FEATURES";
export const CLICKED_FOOTER_TABS_NOT_ON_HEADER = "CLICKED_FOOTER_TABS_NOT_ON_HEADER";
export const PROMO_ARTICLE_FETCH_DATA_REQUEST = 'PROMO_ARTICLE_FETCH_DATA_REQUEST';
export const PROMO_ARTICLE_FETCH_DATA_SUCCESS = 'PROMO_ARTICLE_FETCH_DATA_SUCCESS';
export const PROMO_ARTICLE_FETCH_DATA_ERROR = 'PROMO_ARTICLE_FETCH_DATA_ERROR';
export const PROMO_BANNER_FETCH_DATA_REQUEST = 'PROMO_BANNER_FETCH_DATA_REQUEST';
export const PROMO_BANNER_FETCH_DATA_SUCCESS = 'PROMO_BANNER_FETCH_DATA_SUCCESS';
export const PROMO_BANNER_FETCH_DATA_ERROR = 'PROMO_BANNER_FETCH_DATA_ERROR';